import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { FormattedMessage, intlShape } from "react-intl";

import { CheckboxInput, SelectInput } from "../../../../common/form";
import InfoTooltip from "../../../../common/Tooltip/InfoTooltip";
import { MEMBER, MEMBER_MULTIPLIER } from "../../../admin/guarantees/enums/guaranteeTypes";
import { FR } from "../../../../common/enums/languages";

/**
 * Edit form for a client guarantee configuration.
 * Allows overriding dependsOnGuaranteeId and isAutomaticallyChecked per client.
 */
class ClientGuaranteeEditModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.buildDependsOnOptions = this.buildDependsOnOptions.bind(this);
  }

  buildDependsOnOptions() {
    const { clientGuarantees, initialValues, authLanguageCode } = this.props;
    const lang = authLanguageCode || FR.value;
    const currentGuaranteeId = initialValues && initialValues.guaranteeId;

    const masterConfigs = (clientGuarantees || []).filter(
      (cfg) =>
        cfg.guarantee &&
        cfg.guarantee.isMaster === true &&
        cfg.guaranteeId !== currentGuaranteeId
    );

    return [{ value: "", text: " " }].concat(
      masterConfigs.map((cfg) => {
        const name =
          (cfg.guarantee.localizations &&
            cfg.guarantee.localizations[lang] &&
            cfg.guarantee.localizations[lang].name) ||
          String(cfg.guaranteeId);
        return { value: String(cfg.guaranteeId), text: name };
      })
    );
  }

  isDependsOnDisabled() {
    const { initialValues } = this.props;
    if (initialValues && initialValues.guarantee && initialValues.guarantee.isMaster === true) {
      return true;
    }
    if (initialValues && initialValues.guarantee && initialValues.guarantee.isDrivingMandatoryDependentGuarantee === true) {
      return true;
    }
    return false;
  }

  isAutomaticallyCheckedDisabled() {
    const { initialValues } = this.props;
    const guaranteeType =
      initialValues && initialValues.guarantee && initialValues.guarantee.guaranteeType;
    return guaranteeType === MEMBER.value || guaranteeType === MEMBER_MULTIPLIER.value;
  }

  render() {
    const { handleSubmit, initialValues, authLanguageCode } = this.props;
    const lang = authLanguageCode || FR.value;
    const { formatMessage } = this.context.intl;
    const dependsOnOptions = this.buildDependsOnOptions();
    const dependsOnDisabled = this.isDependsOnDisabled();
    const automaticallyCheckedDisabled = this.isAutomaticallyCheckedDisabled();
    const name = initialValues.guarantee && initialValues.guarantee.localizations && initialValues.guarantee.localizations[lang] && initialValues.guarantee.localizations[lang].name;
    return (
      <form onSubmit={handleSubmit} className="guarantee-edit-form">
        <div className="form-group">
          <label>
            <FormattedMessage id="clientGuarantees.form.guarantee" />
          </label>
          <span className="guarantee-name">{name}</span>
        </div>
        <div className="form-group">
          <label>
            <FormattedMessage id="clientGuarantees.form.dependsOnGuaranteeId" />
            <InfoTooltip
              id="client-depends-on-tooltip"
              text={formatMessage({ id: "clientGuarantees.form.dependsOnGuaranteeIdTooltip" })}
            />
          </label>
          <Field
            id="dependsOnGuaranteeId"
            name="dependsOnGuaranteeId"
            component={SelectInput}
            options={dependsOnOptions}
            disabled={dependsOnDisabled}
            normalize={(value) => (value === "" || value == null ? null : Number(value))}
          />
        </div>

        <div className="form-group">
          <label className="label-with-tooltip">
            <FormattedMessage id="clientGuarantees.form.isAutomaticallyChecked" />
            <InfoTooltip
              id="client-auto-checked-tooltip"
              text={formatMessage({ id: "clientGuarantees.form.isAutomaticallyCheckedTooltip" })}
            />
          </label>
          <Field
            id="isAutomaticallyChecked"
            name="isAutomaticallyChecked"
            component={CheckboxInput}
            groupClassName="checkbox-first"
            checkbox={{ value: true }}
            disabled={automaticallyCheckedDisabled}
            normalize={(value) => !!value}
          />
        </div>
      </form>
    );
  }
}

ClientGuaranteeEditModal.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  clientGuarantees: PropTypes.array,
  authLanguageCode: PropTypes.string,
};

ClientGuaranteeEditModal.contextTypes = {
  intl: intlShape,
};

function mapStateToProps(state) {
  return {
    authLanguageCode: state.auth.user.languageCode,
  };
}

export default connect(mapStateToProps, null, null, { withRef: true })(
  reduxForm({
    form: "clientGuaranteeEdit",
  })(ClientGuaranteeEditModal)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-guarantees/ClientGuaranteeEditModal.js